const path = {
  // site paths
  home: "/",
  courses: "/courses",
  "class-details-find":"/courses/:id",
  login: "/login",
  "about-us": "/about-us",
  "contact-us": "/contact-us",
  // system paths
  dashboard: "/dashboard",
  "the-courses": "/the-courses",
  "course-details":"/the-courses/:id",
  classes: "/classes",
  "class-details":"/classes/:id",
  students: "/students",
  "the-teachers": "/the-teachers",
  requests: "/requests",
  "request-details": "/request-details/:id",
  "the-scheduled-courses": "/the-scheduled-courses",
  schedule: "/schedule",
  workshops:"/workshops",
  "workshop-details":"/workshops/:id",
  "my-students": "/my-students",
  "classes-students": "/classes-students",
  "payments": "/payments",
  "permissions-roles": "/permissions-roles",
  "class-assignments":"/classes/:classId/assignments",
  "class-assignment":"/classes/:classId/assignments/:assignmentId",
  "*": "*",
};
export default path;
